import IdentityVerificationDTO from "../../models/IdentityVerificationDTO";
import {
  VALIDATE_OTP_REQUEST, VALIDATE_OTP_SUCCESS, VALIDATE_OTP_FAILURE,

  VALIDATE_AUTH_REQUESTS, VALIDATE_AUTH_SUCCESS, VALIDATE_AUTH_FAILURE,

  VALIDATE_FACE_AUTH_REQUESTS, VALIDATE_FACE_AUTH_SUCCESS, VALIDATE_FACE_AUTH_FAILURE,

  SUBMIT_UPDATE_REQUEST, SUBMIT_UPDATE_SUCCESS, SUBMIT_UPDATE_FAILURE,

  GET_UPDATE_REQUEST, GET_UPDATE_SUCCESS, GET_UPDATE_FAILURE,

  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,

  FACE_AUTH_REQUEST,
  FACE_AUTH_SUCCESS,
  FACE_AUTH_FAILURE,

  PARTNER_INFO_REQUEST,
  PARTNER_INFO_SUCCESS,
  PARTNER_INFO_FAILURE,

} from "./actionTypes";

export const validateOtpRequest = () => ({
  type: VALIDATE_OTP_REQUEST,
});

export const validateOtpSuccess = (user) => ({
  type: VALIDATE_OTP_SUCCESS,
  payload: user,
});

export const validateOtpFailure = (error) => ({
  type: VALIDATE_OTP_FAILURE,
  payload: error,
});


export const validateAuthRequest = () => ({
  type: VALIDATE_AUTH_REQUESTS,
});

export const validateAuthSuccess = (user) => ({
  type: VALIDATE_AUTH_SUCCESS,
  payload: user,
});

export const validateAuthFailure = (error) => ({
  type: VALIDATE_AUTH_FAILURE,
  payload: error,
});

export const validateFaceAuthRequest = () => ({
  type: VALIDATE_FACE_AUTH_REQUESTS,
});

export const validateFaceAuthSuccess = (user) => ({
  type: VALIDATE_FACE_AUTH_SUCCESS,
  payload: user,
});

export const validateFaceAuthFailure = (error) => ({
  type: VALIDATE_FACE_AUTH_FAILURE,
  payload: error,
});


export const validateSubmitRequest = () => ({
  type: SUBMIT_UPDATE_REQUEST,
});

export const validateSubmitSuccess = (user) => ({
  type: SUBMIT_UPDATE_SUCCESS,
  payload: user,
});

export const validateSubmitFailure = (error) => ({
  type: SUBMIT_UPDATE_FAILURE,
  payload: error,
});



export const getUpdateRequest = () => ({
  type: GET_UPDATE_REQUEST,
});

export const getUpdateSuccess = (user) => ({
  type: GET_UPDATE_SUCCESS,
  payload: user,
});

export const getUpdateFailure = (error) => ({
  type: GET_UPDATE_FAILURE,
  payload: error,
});


export const getAuthRequest = () => ({
  type: AUTH_REQUEST,
});

export const getAuthSuccess = (user) => ({
  type: AUTH_SUCCESS,
  payload: user,
});

export const getAuthFailure = (error) => ({
  type: AUTH_FAILURE,
  payload: error,
});

export const getFaceAuthRequest = () => ({
  type: FACE_AUTH_REQUEST,
});

export const getFaceAuthSuccess = (user) => ({
  type: FACE_AUTH_SUCCESS,
  payload: user,
});

export const getFaceAuthFailure = (error) => ({
  type: FACE_AUTH_FAILURE,
  payload: error,
});

export const getPartnerInfoRequest = (user) => ({
  type: PARTNER_INFO_REQUEST,
  payload: user,
});

export const getPartnerInfoSuccess = (user) => ({
  type: PARTNER_INFO_SUCCESS,
  payload: user,
});

export const getPartnerInfoFailure = (error) => ({
  type: PARTNER_INFO_FAILURE,
  payload: error,
});

export const setUIN = (uin, verificationMethod) => {
  return {
    type: 'SET_UIN',
    payload: {
      uin,
      verificationMethod,
    },
  };
};

export const clearUIN = () => {
  return {
    type: 'CLEAR_UIN',
  };
};

export const clearStateAction = () => {
  return {
    type: 'CLEAR_STATE',
  };
};

export const setVerified = () => ({
  type: 'SET_VERIFIED',
  payload: true
});

export const setLogin = () => ({
  type: 'LOGIN',
  payload: true
});

export const setAuthenticated = () => ({
  type: 'SET_AUTHENTICATED',
  payload: true
});

export const verifyRegistration = () => ({
  type: ''
})


export const loginSuccess = (identityInfoDTO) => ({
  type: 'VALIDATE_OTP_SUCCESS', 
  payload: IdentityVerificationDTO.toPlainObject(identityInfoDTO) 
});

export const RESET_ALL_STATES = 'RESET_ALL_STATES';
export const RESET_SUBMIT_STATE = 'RESET_SUBMIT_STATE';
